import React, { Component } from 'react'
import { connect } from 'react-redux'
import { hidePakketModal, showMessageModal } from '../../../redux/actions/miscActions'
import { updatePakket } from '../../../redux/actions/productActions'
import { single, multiple } from "../../../utils/Eenheden";
import { Modal , Form, Input, InputNumber, Select, Space } from 'antd'

const { Option } = Select

export class EditPakketModal extends Component {
  constructor(props){
    super(props)
    this.state={
      editPakket: {},
      isProductenModalVisible: false,
      typePakket: '',
      pakketNaam: "",
      pakketPrijs: '',
      productId: '',
      volgNum: '',
      productImage: '',
      imgPreview: '',
      producten: []
    }
  }
  
  handleCancel=()=>{
    this.props.hidePakketModal()
    this.setState({
      editPakket: {},
      isProductenModalVisible: false,
      typePakket: '',
      pakketNaam: "",
      pakketPrijs: '',
      productId: '',
      volgNum: '',
      productImage: '',
      imgPreview: '',
      producten: []
    })
  }

  componentDidUpdate=(prevProps)=>{    
    if(prevProps.misc.editPakket !== this.props.misc.editPakket){
      const { editPakket } = this.props.misc
      this.setState({
        ...editPakket,
        imgPreview: editPakket.productImage
      })
      // this.setState({
      //   pakketPrijs, pakketPrijsEuro, producten: producten.length > 0 ? producten : [], pakketNaam, productId, productImage, imgPreview: productImage
      // })
    }
  }
  
  componentWillUnmount=()=>{
    this.setState({
      editPakket: {}
    })
  }

  handleImageSelect = (e) => {
    if (e.target.files.length === 1) {
      const imgPreview = URL.createObjectURL(e.target.files[0]);
      this.setState({
        imgPreview,
        productImage: e.target.files[0],
      });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleNumberInput = (e) => {

    if (e.target.value.match(/^[0-9]+([0-9,]{1,3})?$/gm)) {
      this.setState({
        [e.target.name]: e.target.value,
      });
    } else if (e.target.value.length === 0) {
      this.setState({
        [e.target.name]: "",
      });
    }
  };

  showProductenModal=()=>{
    this.setState({
      isProductenModalVisible: true
    })
  }

  hideProductenModal=()=>{
    this.setState({
      isProductenModalVisible: false
    })
  }

  shouldComponentUpdate=(nextState)=>{
    
    if(nextState.producten !== this.state.producten){
      return true
    }
  }

  handlePakketUpdate=()=>{
    const { id } = this.props.misc.editPakket;
    const { pakketPrijs, pakketNaam, productId, volgNum, producten, productImage, typePakket } = this.state
    const data = {pakketPrijs, pakketNaam, productId, volgNum, producten, productImage, typePakket}
    data.pakketPrijs = pakketPrijs.replace(/,/g, ".");
    if(pakketNaam && pakketPrijs && producten.length > 0 && productImage && typePakket && volgNum){
      this.props.updatePakket(id, data)
    } else {
      const feedback = {
        type: "warning",
        txt: "Controleer als alle velden zijn ingevuld.",
      };
      this.props.showMessageModal(feedback);
    }
  }

  onFinish=(value)=>{
    const { selectedProducts } = value
    
    this.setState({
      producten: selectedProducts
    })
  }

  handleCatSelect = (value) => {
    this.setState({
      typePakket: value,
    });
  };
  
  render() {
    const { isPakketModalVisible } = this.props.misc
    const { allClientProducts } = this.props.products;
    
    const {pakketPrijs, pakketPrijsEuro, producten, pakketNaam, productId, volgNum, isProductenModalVisible, imgPreview, typePakket} = this.state
      
    const productsSelList = [];
    allClientProducts.map((x) =>
      productsSelList.push(
        <Option key={x.id} value={x.productNaam}>
          {x.productNaam}
        </Option>
      )
    );

    const listedProducts = producten.map(x => {return(
      <li key={x.id} className="listed-products">
        {x.aantalNum} x {x.aantalNum > 1 ? multiple[x.productEenheid] : single[x.productEenheid]} {x.productNaam}
      </li>
    )})




    return (
      <div>
        <Modal
        className="edit-pakket-modal"
        footer={null}
        visible={isPakketModalVisible}
        onCancel={this.handleCancel}
        >
          <Form layout='vertical'>

          <Form.Item label="Pakket foto">
              <div className="image-preview">
                <img src={imgPreview} alt="" />
                <Input
                  type="file"
                  className="form-control-file"
                  onChange={this.handleImageSelect}
                />
              </div>
            </Form.Item>

            <Form.Item>
          <Input
              name="pakketNaam"
              onChange={this.handleInput}
              value={pakketNaam}
            />
          </Form.Item>
          <div className="prijzen-input">
            <Form.Item label="Prijs" required={true}>
              <Input
                prefix="SRD"
                name="pakketPrijs"
                onChange={this.handleNumberInput}
                value={pakketPrijs}
              />
            </Form.Item>
          </div>

          <Form.Item label="Pakket categorie" required={true}>
            <Select value={typePakket} onChange={this.handleCatSelect}>
            <Option value="healthy_greans_small">Healthy greans small</Option>
              <Option value="healthy_greans_medium">Healthy greans medium</Option>
              <Option value="healthy_greans_large">Healthy greans large</Option>
            </Select>
          </Form.Item>

          <div className="prijzen-input">

          <Form.Item
            label="Pakket ID"
            required={true}
            >
            <Input
              name="productId"
              onChange={this.handleInput}
              value={productId}
              />
          </Form.Item>

          <Form.Item
            label="Volg nummer"
            required={true}
            >
            <Input
              name="volgNum"
              onChange={this.handleInput}
              value={volgNum}
              />
          </Form.Item>
              </div>

          <ul className="listed-products">
          {listedProducts}
          </ul>
          <button  onClick={this.showProductenModal}>Producten aanpassen</button>
          <button
              onClick={this.handlePakketUpdate}
              className="large-main-btn"
            >
              Opslaan
            </button>
          </Form>
          <Modal
          className="edit-pakket-modal sec-modal"
          footer={null}
          visible={isProductenModalVisible}
          onCancel={this.hideProductenModal}
          destroyOnClose={true}
          >
<div className="pakketten-product-form">  
        <Form name="dynamic_form_item" onFinish={this.onFinish} initialValues={{selectedProducts: producten}}>
<Form.List name='selectedProducts' >
        {(fields, { add, remove }) => (
          <>
            {fields.map(field => (
              <Space key={field.key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                <Form.Item
                  {...field}
                  name={[field.name, 'aantalNum']}
                  fieldKey={[field.fieldKey, 'aantalNum']}
                >
                  <InputNumber min={0} defaultValue={0}/>
                </Form.Item>
                <Form.Item {...field}
                name={[field.name, 'productEenheid']}
                fieldKey={[field.fieldKey, 'productEenheid']}
                >
            <Select 
            showSearch
            style={{ width: 145 }}
            placeholder="Eenheid"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
            >
                 <Option value="stuk">stuk</Option>
              <Option value="hoop">hoop</Option>
              <Option value="hoop(4x)">hoop(4x)</Option>
              <Option value="hoop(8x)">hoop(8x)</Option>
              <Option value="1/2hand">1/2hand</Option>
              <Option value="takjes(4x)">takjes(4x)</Option>
              <Option value="bosje">bosje</Option>
              <Option value="pakje">pakje</Option>
            </Select>
          </Form.Item>
                <Form.Item
                  {...field}
                  name={[field.name, 'productNaam']}
                  fieldKey={[field.fieldKey, 'productNaam']}
                >
                  <Select
                  showSearch
                  style={{ width: 200 }}
                  placeholder="Product"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  >{productsSelList}</Select>
                </Form.Item>
                <button className="remove-field-button" onClick={() => remove(field.name)}> - </button>
              </Space>
            ))}
            <Form.Item>
              <button className="add-field-button" onClick={() => add()}>
                Product toevoegen
              </button>
            </Form.Item>
          </>
        )}
      </Form.List>
      <button htmlType='submit' className="large-main-btn">Opslaan</button>
</Form>
      </div>
          </Modal>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps=(state)=>({
  misc: state.misc,
  products: state.products
})

export default connect(mapStateToProps, {hidePakketModal, updatePakket, showMessageModal})(EditPakketModal)
